<template>
	<div class="Tortvocabulary">
		<el-form
			class="custom-formScreen"
			ref="formScreen"
			:model="formScreen"
			label-width="4.8vw"
			inline
		>
			<el-form-item
				label="分公司选择"
				prop="branchCompanyId"
				v-if="UserInfo.type === 1 && UserInfo.system === 1"
			>
				<el-select
					v-model="formScreen.branchCompanyId"
					@change="selectChange"
				>
					<el-option
						v-for="item in listBranch"
						:key="item.id"
						:label="item.companyFullName"
						:value="item.id"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item
				label="子公司选择"
				prop="companyId"
				v-if="UserInfo.type === 1 && UserInfo.system === 1"
			>
				<el-select v-model="formScreen.companyId">
					<el-option
						v-for="item in listSon"
						:key="item.id"
						:label="item.companyFullName"
						:value="item.id"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="状态" prop="status">
				<el-select v-model="formScreen.status">
					<el-option
						v-for="(value, key) in listStatus"
						:key="key"
						:label="value.label"
						:value="key"
					></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="类型" prop="classifyId">
				<el-select
					v-model="formScreen.classifyId"
					placeholder="请选择"
					style="width:100%;"
				>
					<el-option
						v-for="item in ClassList"
						:key="item.id"
						:label="item.classifyContent"
						:value="item.id"
					>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="侵权国家" prop="countryCode">
				<el-select
					v-model="formScreen.countryCode"
					placeholder="请选择"
					style="width:100%;"
				>
					<!-- <el-option
              v-for="item in CompanyList"
              :key="item.value"
              :label="item.countryName"
              :value="item.countryCode">
            </el-option> -->
					<el-option
						v-for="item in CompanyList"
						:key="item.countryCode"
						:label="item.countryName"
						:value="item.countryCode"
					>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="开始时间" prop="startTimeString">
				<el-date-picker
					v-model="formScreen.startTimeString"
					type="datetime"
					placeholder="选择日期"
					format="yyyy-MM-dd HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item label="结束时间" prop="endTimeString">
				<el-date-picker
					v-model="formScreen.endTimeString"
					type="datetime"
					placeholder="选择日期"
					format="yyyy-MM-dd HH:mm:ss"
					value-format="yyyy-MM-dd HH:mm:ss"
				>
				</el-date-picker>
			</el-form-item>
			<el-form-item label=" " prop="searchString" style="width: 40%;">
				<el-input
					v-model="formScreen.searchString"
					style="width: calc(100% - 140px);margin-right: 10px;"
					placeholder="侵权词汇"
				></el-input>
				<el-button type="primary" @click="searchForm">搜索</el-button>
				<el-button type="primary" @click="resetForm">重置</el-button>
			</el-form-item>
		</el-form>
		<el-row style="margin-bottom: 10px;">
			<el-button type="primary" @click="increaseWord"
				>添加侵权词汇</el-button
			>
			<el-button
				type="primary"
				@click="ClassADD"
				v-if="this.UserInfo.type == 1 && this.UserInfo.system == 1"
				>添加分类</el-button
			>
		</el-row>
		<el-table
			:data="listTable"
			border
			:header-cell-style="{ textAlign: 'center' }"
		>
			<el-table-column
				prop="words"
				label="侵权词汇"
				align="center"
			></el-table-column>
			<el-table-column prop="" label="状态" align="center" width="100">
				<template slot-scope="scope">
					<div :style="{ color: listStatus[scope.row.status].color }">
						{{ listStatus[scope.row.status].label }}
					</div>
				</template>
			</el-table-column>
			<el-table-column
				prop="classifyContent"
				label="类型"
				align="center"
			></el-table-column>
			<el-table-column
				prop="countryName"
				label="侵权国家"
				align="center"
			></el-table-column>
			<el-table-column
				prop="method"
				label="处理建议"
				align="center"
			></el-table-column>
			<el-table-column
				prop="roleName"
				label="添加人"
				align="center"
				v-if="UserInfo.type === 1 && UserInfo.system === 1"
				width="150"
			></el-table-column>
			<el-table-column
				prop="createTime"
				label="添加时间"
				align="center"
			></el-table-column>
			<el-table-column
				prop=""
				label="提交公司"
				align="center"
				v-if="UserInfo.type === 1 && UserInfo.system === 1"
			>
				<template slot-scope="scope">
					<el-row type="flex" justify="center">
						<div v-if="scope.row.branchCompanyName">
							{{ `${scope.row.branchCompanyName || ''}` }}
						</div>
						<div
							v-if="
								scope.row.branchCompanyName &&
									scope.row.subCompanyName
							"
						>
							-
						</div>
						<div v-if="scope.row.subCompanyName">
							{{ `${scope.row.subCompanyName || ''}` }}
						</div>
					</el-row>
				</template>
			</el-table-column>
			<el-table-column
				label="操作"
				align="center"
				width="100"
				v-if="UserInfo.type === 1 && UserInfo.system === 1"
			>
				<template slot-scope="scope">
					<el-button
						type="primary"
						icon="el-icon-edit-outline"
						@click="updateWord(scope.row)"
					></el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-row
			class="pagination-box"
			type="flex"
			justify="center"
			align="middle"
		>
			<el-pagination
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
		</el-row>

		<el-dialog
			title="添加侵权词汇"
			width="600px"
			:visible.sync="dialogIncreaseVisible"
		>
			<el-form label-width="100px">
				<el-form-item label="类型：">
					<el-select
						v-model="dialogIncreaseForm.classifyId"
						placeholder="请选择"
						style="width:100%;"
					>
						<el-option
							v-for="item in ClassList"
							:key="item.id"
							:label="item.classifyContent"
							:value="item.id"
						>
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="侵权词汇：">
					<el-input v-model="dialogIncreaseForm.words"></el-input>
				</el-form-item>
				<el-form-item label="侵权国家：">
					<!-- <el-select v-model="dialogIncreaseForm.countryCode" placeholder="请选择" style="width:100%;">
            <el-option
              v-for="item in CompanyList"
              :key="item.id"
              :label="item.countryName"
              :value="item.countryCode">
            </el-option>
          </el-select> -->

					<el-checkbox-group
						v-model="dialogIncreaseForm.countryCodes"
					>
						<el-checkbox label="GB">英国</el-checkbox>
						<el-checkbox label="DE">德国</el-checkbox>
						<el-checkbox label="FR">法国</el-checkbox>
						<el-checkbox label="IT">意大利</el-checkbox>
						<el-checkbox label="ES">西班牙</el-checkbox>
						<el-checkbox label="NL">荷兰</el-checkbox>
						<el-checkbox label="SE">瑞典</el-checkbox>
						<el-checkbox label="PL">波兰</el-checkbox>
						<el-checkbox label="SA">沙特阿拉伯</el-checkbox>
						<el-checkbox label="US">美国</el-checkbox>
						<el-checkbox label="CA">加拿大</el-checkbox>
						<el-checkbox label="MX">墨西哥</el-checkbox>
						<el-checkbox label="JP">日本</el-checkbox>
						<el-checkbox label="AU">澳洲</el-checkbox>
						<el-checkbox label="AE">阿联酋</el-checkbox>
						<el-checkbox label="SG">新加坡</el-checkbox>
						<el-checkbox label="IN">印度</el-checkbox>
						<el-checkbox label="BR">巴西</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-form-item label="侵权理由：">
					<el-input
						type="textarea"
						v-model="dialogIncreaseForm.method"
					></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button
					type="primary"
					@click="submitIncrease"
					:loading="loadingIncrease"
					>提 交</el-button
				>
			</div>
		</el-dialog>

		<el-dialog
			title="编辑侵权词汇"
			width="600px"
			:visible.sync="dialogUpdateVisible"
		>
			<el-form
				label-width="100px"
				v-if="Object.keys(dialogUpdateForm).length"
			>
				<el-form-item label="类型：">
					<div>{{ dialogUpdateForm.classifyContent }}</div>
				</el-form-item>
				<el-form-item label="侵权词汇：">
					<div>{{ dialogUpdateForm.words }}</div>
				</el-form-item>
				<el-form-item label="侵权国家：">
					<div>{{ dialogUpdateForm.countryName }}</div>
				</el-form-item>
				<el-form-item label="处理建议：">
					<el-input
						type="textarea"
						v-model="dialogUpdateForm.method"
					></el-input>
				</el-form-item>
				<el-form-item label="状态：">
					<el-radio-group v-model="dialogUpdateForm.status">
						<el-radio :label="0">未收录</el-radio>
						<el-radio :label="1">已收录</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="状态：">
					<el-radio-group v-model="dialogUpdateForm.openType">
						<el-radio :label="0">未公示</el-radio>
						<el-radio :label="1">已公示</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button type="primary" @click="submitUpdateWord"
					>提 交</el-button
				>
			</div>
		</el-dialog>

		<el-dialog title="添加分类" :visible.sync="classification" width="30%">
			<el-row>
				<el-input style="width:80%;" v-model="classInput"></el-input>
				<el-button
					@click="AddClass"
					style="margin-left:15px;"
					type="primary"
					>添加</el-button
				>
			</el-row>
			<el-table
				:data="ClassList"
				border
				style="width: 100%;margin-top:10px;"
			>
				<el-table-column
					prop="classifyContent"
					label="分类名称"
					align="center"
				></el-table-column>
				<el-table-column label="操作" align="center">
					<template slot-scope="scope">
						<el-button type="danger" @click="DelClass(scope.row)"
							>删除</el-button
						>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
	name: 'Tortvocabulary',
	data() {
		return {
			UserInfo: {},
			page: 1,
			size: 20,
			total: 0,
			listBranch: [],
			listSon: [],
			ClassList: [],
			CompanyList: [
				{ countryName: '英国', countryCode: 'GB', id: '1' },
				{ id: 2, countryName: '德国', countryCode: 'DE' },
				{ id: 3, countryName: '法国', countryCode: 'FR' },
				{ id: 4, countryName: '意大利', countryCode: 'IT' },
				{ id: 5, countryName: '西班牙', countryCode: 'ES' },
				{ id: 6, countryName: '荷兰', countryCode: 'NL' },
				{ id: 7, countryName: '瑞典', countryCode: 'SE' },
				{ id: 8, countryName: '波兰', countryCode: 'PL' },
				{ id: 9, countryName: '沙特阿拉伯', countryCode: 'SA' },
				{ id: 10, countryName: '美国', countryCode: 'US' },
				{ id: 11, countryName: '加拿大', countryCode: 'CA' },
				{ id: 12, countryName: '墨西哥', countryCode: 'MX' },
				{ id: 13, countryName: '日本', countryCode: 'JP' },
				{ id: 14, countryName: '澳洲', countryCode: 'AU' },
				{ id: 15, countryName: '阿联酋', countryCode: 'AE' },
				{ id: 16, countryName: '新加坡', countryCode: 'SG' },
				{ id: 17, countryName: '印度', countryCode: 'IN' },
				{ id: 18, countryName: '巴西', countryCode: 'BR' },
			],
			classInput: '',
			listStatus: {
				0: { color: 'red', label: '未收录' },
				1: { color: 'green', label: '已收录' },
			},
			formScreen: {
				startTimeString: '',
				endTimeString: '',
				branchCompanyId: '',
				companyId: '',
				searchString: '',
				status: '',
				classifyId: '',
				countryCode: null,
			},
			listTable: [],
			dialogIncreaseVisible: false,
			dialogIncreaseForm: {},
			loadingIncrease: false,
			classification: false,
			dialogUpdateVisible: false,
			dialogUpdateForm: {},
		}
	},
	created() {
		this.UserInfo = JSON.parse(localStorage.getItem('role'))
		this.getListTable()
		this.getBranchCompanyList()
		this.ClassAjax()
	},
	methods: {
		handleSizeChange(val) {
			this.size = val
			this.getListTable()
		},
		handleCurrentChange(val) {
			this.page = val
			this.getListTable()
		},
		selectChange(id) {
			this.listSon = []
			this.formScreen.companyId = ''
			this.getSonCompanyList(id)
		},
		getBranchCompanyList() {
			const API = Baseurl + 'logisticsController/getAllBranchCompany'
			ajaxPost(API).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listBranch = data
				}
			})
		},
		getSonCompanyList(id) {
			const API = Baseurl + 'logisticsController/getAllSubCompanyById'
			const paramsData = { id }
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listSon = data
				}
			})
		},
		searchForm() {
			this.page = 1
			this.getListTable()
		},
		resetForm() {
			this.page = 1
			this.listSon = []
			this.$refs.formScreen.resetFields()
			this.searchForm()
		},
		getListTable() {
			const API =
				Baseurl + 'sensitiveWordsController/getSensitiveWordsList'
			const paramsData = {
				page: this.page,
				size: this.size,
				...this.formScreen,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.listTable = data.list
					this.total = data.total
				}
			})
		},
		increaseWord() {
			this.dialogIncreaseVisible = true
			this.dialogIncreaseForm = {
				words: '',
				classifyId: '',
				countryCodes: [],
				method: '',
			}
		},
		submitIncrease() {
			if (!this.dialogIncreaseForm.words) {
				return
			}
			const API =
				Baseurl + 'sensitiveWordsController/insertSensitiveWords'
			const paramsData = {
				roleId: this.UserInfo.rid,
				companyId: this.UserInfo.company_id,
				...this.dialogIncreaseForm,
			}
			this.loadingIncrease = true
			ajaxPost(API, paramsData)
				.then((res) => {
					const { code, data } = res.data
					if (code === 200) {
						this.dialogIncreaseVisible = false
						this.getListTable()
						this.$message.success('操作成功')
					} else {
						this.$message.error(data || '操作失败')
					}
				})
				.finally(() => {
					this.loadingIncrease = false
				})
		},
		updateWord(row) {
			this.dialogUpdateForm = JSON.parse(JSON.stringify(row))
			// console.log(this.dialogUpdateForm)
			this.dialogUpdateVisible = true
		},
		submitUpdateWord() {
			const API =
				Baseurl + 'sensitiveWordsController/updateSensitiveWords'
			const paramsData = {
				id: this.dialogUpdateForm.id,
				method: this.dialogUpdateForm.method,
				status: this.dialogUpdateForm.status,
				openType: this.dialogUpdateForm.openType,
			}
			ajaxPost(API, paramsData).then((res) => {
				const { code, data } = res.data
				if (code === 200) {
					this.getListTable()
					this.dialogUpdateVisible = false
					this.$message.success('操作成功')
				} else {
					this.$message.error(data || '操作失败')
				}
			})
		},
		ClassADD() {
			this.classification = true
			this.ClassAjax()
		},
		ClassAjax() {
			ajaxPost(Baseurl + 'classifyController/selectClassifyList').then(
				(res) => {
					if (res.data.code == 200) {
						this.ClassList = res.data.data
					}
				}
			)
		},
		AddClass() {
			var obj = {
				classifyContent: this.classInput,
				companyId: this.UserInfo.company_id,
				roleId: this.UserInfo.rid,
			}
			ajaxPost(Baseurl + 'classifyController/insertClassify', obj).then(
				(res) => {
					if (res.data.code == 200) {
						this.ClassAjax()
					}
				}
			)
		},
		DelClass(val) {
			var obj = {
				id: val.id,
			}
			ajaxPost(
				Baseurl + 'classifyController/deleteClassifyById',
				obj
			).then((res) => {
				if (res.data.code == 200) {
					this.ClassAjax()
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.Tortvocabulary {
	width: 98%;
	padding-bottom: 52px;

	.pagination-box {
		width: calc(97% - 200px);
		background: #fff;
		position: fixed;
		bottom: 0;
		left: 200px;
		padding: 10px;
		z-index: 999;
	}
}
</style>
